// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hEvGUnQiV6Eab1v9iJwL {
  color: #A3030A;
  padding: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/components/error-message/error-message.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".errorMsgWrap {\n  color: #A3030A;\n  padding: 1rem 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMsgWrap": `hEvGUnQiV6Eab1v9iJwL`
};
export default ___CSS_LOADER_EXPORT___;
